export default "__VITE_ASSET__hTYZYYcV__"